@import '../../../../../styles/global/global-imports';

:host,
envc-text-mit-image {
  width: 100%;
  display: block;

  h1 {
    font-size: var( --headline-h1-font-size);
    line-height: var(--headline-h1-line-height);
    margin: var(--headline-h1-margin);
  }

  h2 {
    font-size: var( --headline-h2-font-size);
    line-height: var(--headline-h2-line-height);
    margin: var(--headline-h2-margin);
  }

  h3 {
    font-size: var( --headline-h3-font-size);
    line-height: var(--headline-h3-line-height);
    margin: var(--headline-h3-margin);
  }

  p {
    font-size: var( --copy-text-font-size);
    line-height: var(--copy-text-line-height);
  }
}
